export default __webpack_public_path__ + "images/assets/959221bab85f5bef2c452d3a01ab8cc4.svg";